import html2pdf from 'html2pdf.js'
import { db } from '@/shared/services/firebase'
import { calculateOverHoursInPeriod, calculateShift, getHoliday, getEve } from '@/shared/services/invoice-calc'

const getCost = (contract, user) => {
  let finalPrice = contract.price
  if (contract && contract.contractId) {
    if (contract && contract.price) {
      finalPrice = contract.price
    }
  }
  const keys = ['default'].concat(Object.keys(finalPrice).filter(key => user.role.canWorkAs.includes(key)))
  if (user.love) {
    keys.push('love')
  }
  let result = 0
  keys.forEach(key => {
    result = finalPrice[key] > result ? finalPrice[key] : result
  })
  return result
}

const getOverHoursInPeriod = (invoice, jaksoPeriod, maxHours, users, shifts, contract, areaIds) =>{
  const invoiceCopy = {...invoice}
  let overHoursByUsers
  // Fetch shifts from jakso period
  try {
    const periodShifts = shifts.filter(shift => shift.start >= jaksoPeriod.start && shift.start <= jaksoPeriod.end && areaIds.includes(shift.areaId))
    // Get users who had temp contracts valid in jakso period
    const activeUsers = users.filter(user => user !== null && user.tempContract && user.tempContract.length > 0 && user.tempContract.some(tempContract => {
        const {areaId} = tempContract
        const contractStart = tempContract.startDate.toDate()
        const contractEnd = tempContract.endDate.toDate()
        return (contractStart <= jaksoPeriod.start && contractEnd >= jaksoPeriod.end && areaIds.includes(areaId))
      })).map(user => ({
        ...user,
        tempContract: user.tempContract.filter(tempContract => {
          const contractStart = tempContract.startDate.toDate()
          const contractEnd = tempContract.endDate.toDate()
          return (contractStart <= jaksoPeriod.start && contractEnd >= jaksoPeriod.start) || (contractStart >= jaksoPeriod.start && contractStart <= jaksoPeriod.end)
        }),
      }))
      overHoursByUsers = activeUsers.map(activeUser => {
      // Get shifts for user
      const userShifts = periodShifts.filter(shift => shift.assignedTo === activeUser.id)
      // Get max hours for user
      const overHours = calculateOverHoursInPeriod(userShifts, maxHours)
      const baseCost = getCost(contract, activeUser)
      return {
        overHours50: overHours > 18 ? 18 : overHours,
        overHours100: overHours > 18 ? overHours - 18 : 0,
        baseCost,
        user: activeUser,
      }
    })
  // Add overhours to payroll
  if(overHoursByUsers.length > 0) {
    overHoursByUsers.forEach(overHours => {
      // Title in the form of: Jakso 5.6-25.6 ylityö 50%
      const title= `${overHours.user.fullName} jakso ${jaksoPeriod.start.toLocaleDateString('fi', {month: "numeric", day: "numeric"})} - ${jaksoPeriod.end.toLocaleDateString('fi', {month: "numeric", day: "numeric"})} ylityö`
      if(overHours.overHours50 > 0) {
        invoiceCopy.total += overHours.baseCost * 0.5 * overHours.overHours50
        invoiceCopy.hasJaksoOverHours = true
        invoiceCopy.items.push({
          title: `${title} 50%` ,
          qty: overHours.overHours50,
          unit: 'tuntia',
          cost: overHours.baseCost * 0.5,
          total: overHours.baseCost * 0.5 * overHours.overHours50,
        })
      }
      if(overHours.overHours100 > 0) {
        invoiceCopy.total += overHours.baseCost * overHours.overHours100
        invoiceCopy.items.push({
          title: `${title} 100%`,
          qty: overHours.overHours100,
          unit: 'tuntia',
          cost: overHours.baseCost,
          total: overHours.baseCost * overHours.overHours100,
        })
      }
    })
  }
  return {invoice: invoiceCopy, overHoursByUsers: overHoursByUsers?.filter(overHours => overHours.overHours50 > 0)}
  } catch (error) {
    return {invoice: invoiceCopy, overHoursByUsers}
  }
}


const createJaksoPeriodInvoice = (jaksoPeriod, account, periodShifts, users, maxHours, contract, areas, VAT) => {
  const today = new Date()
  const dueDate = new Date()
  dueDate.setDate(today.getDate() + 21)
  const areaIds = areas.map(area => area.id)
  const name = `Jakso ylityöt ${jaksoPeriod.start.toLocaleDateString('fi', {month: 'numeric', day: 'numeric'})} - ${jaksoPeriod.end.toLocaleDateString('fi', {month: 'numeric', day: 'numeric'})}`
  let invoice = {
    areaId: areaIds[0],
    date: today,
    total: 0,
    items: [],
    from: jaksoPeriod.start,
    to: jaksoPeriod.end,
    status: 'pending',
    name,
    accountId: account.id,
    customerNumber: account.customerNumber || '',
    factoring: !!account.factoring,
    dueDate,
    VAT
  }
  const result = getOverHoursInPeriod(invoice, jaksoPeriod, maxHours, users, periodShifts, contract, areaIds)
  invoice = result.invoice
  const {overHoursByUsers} = result
  const includedShifts = periodShifts.filter(shift => overHoursByUsers.some(overHours => overHours.user.id === shift.assignedTo)).sort((a, b) => {
    if (a.areaId < b.areaId) {
      return -1
    }
    if (a.areaId > b.areaId) {
      return 1
    }
    return 0
  })
  includedShifts.forEach(shift => {
    const baseCost = 0
    const unpaidTime = contract.unpaidTime || 0
    const report = calculateShift(shift.start, shift.end, baseCost, false, false, unpaidTime, account.accountType === 'public')
    const user = users.find(u => u !== null && u.id === shift.assignedTo)
    const area = areas.find(a => a.id === shift.areaId)
    let title = `${user.fullName} ${area.name}`
    title = `${title.trim()} ${shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })}`
    const startTime = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
    const endTime = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
    const shiftPeriod = `klo ${startTime} - ${endTime}`
      const qty = report.perus.hours
      const cost = baseCost
      const total = cost * qty
      invoice.total += total
      invoice.items.push({
        title: `${title} ${shiftPeriod}`,
        qty,
        unit: 'tuntia',
        cost,
        total,
      })
  })
  
  return invoice
}

const fetchBankDetails = () => db.collection('bankDetails')
  .doc('tAPzJiOPGXBtVhd6EVRW')
  .get()
  .then(doc => doc.data())
  .catch(() => null)

const exportCSVList = async (invoices, overrideVAT = false) => {
  let csv = ''
  invoices.forEach(invoice => {
    const row = []
    const invoiceVAT = invoice.VAT
    row.push('M') // 1 = M
    row.push('EUR') // 2= EUR
    row.push('') // 3 = empty,
    row.push('') // 4= empty,
    row.push('') // 5 = empty,
    row.push('Bank transfer') // 6 = Bank transfer,
    row.push('') // 7 = empty,
    row.push('online') // 8 = online
    row.push('') // 9 = empty
    row.push('f') // 10 = f
    row.push('') // 11 = empty
    row.push('') // 12 = empty
    row.push(new Date().toLocaleString('fi')) // 13=dd.mm.yyyy
    // 14 - 18 empty
    for (let i = 0; i < 5; i += 1) {
      row.push('')
    }
    row.push(invoice.name) // 19 = invoice name
    // 20 - 23 empty
    for (let i = 0; i < 4; i += 1) {
      row.push('')
    }
    row.push('') // 24 = invoice total
    row.push(0) // 25 = 0
    row.push(3) // 26 = E-invoice
    // 27 - 31 empty
    for (let i = 0; i < 5; i += 1) {
      row.push('')
    }
    row.push(invoice.customerNumber || invoice.accountId) // 32 = accountId or customer number
    row.push('') // 33 Invoice for sending (X) means sending
    // 34 - 39 empty
    for (let i = 0; i < 6; i += 1) {
      row.push('')
    }
    row.push(invoice.factoring ? '001' : '') // 40 = factoring
    for (let i = 0; i < 8; i += 1) {
      row.push('')
    }
    csv += row.join(';')
    csv += '\n'
    // Print invoice row
    invoice.items.forEach(item => {
      const itemRow = []
      itemRow.push('') // 1 = Empty
      itemRow.push(item.title) // 2 = Product description
      itemRow.push('') // 3 = Product code
      itemRow.push(parseFloat(item.qty).toFixed(2)) // 4 = Qty
      itemRow.push(item.unit) //  5 = Unit
      itemRow.push(parseFloat(item.cost ? item.cost : 0).toFixed(2)) //  6 = Cost
      for (let i = 0; i < 11; i += 1) {
        if (!overrideVAT && invoiceVAT === true && i === 1) {
          itemRow.push(parseFloat(25.5).toFixed(1)) // 8 = %VAT
        }
        itemRow.push('')
      }
      csv += itemRow.join(';')
      csv += '\n'
    })
  })
  const hiddenElement = document.createElement('a')
  hiddenElement.href = `data:text/csv;base64,${btoa(csv)}`
  hiddenElement.target = '_blank'
  // provide the name for the CSV file to be downloaded
  hiddenElement.download = 'Lasku.csv'
  hiddenElement.click()
}

const createElementPdf = async invoiceData => {
  const bankDetails = await fetchBankDetails()
  const { logoName, name } = this.$store.state.app.appConfig
  return `
    <div class="card invoice-preview-card">
      <div class="card-body invoice-padding pb-0">
        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
          <div>
            <div class="logo-wrapper">
              <span class="brand-logo">
                <img src="require(${`@hw-ui/assets/images/logo/${logoName}`})" alt="logo" style="width: 50px;">
              </span>
              <h3 class="invoice-logo"> ${name} </h3>
            </div>
            <p class="card-text mb-25"> ${bankDetails ? bankDetails.address.streetAddress : ''} </p>
            <p class="card-text mb-25"> ${bankDetails ? bankDetails.address.postcode : ''} ${bankDetails ? bankDetails.address.city : ''} </p>
            <p class="card-text mb-0"> ${bankDetails ? bankDetails.contact : ''} </p>
            <p class="card-text mb-0"> Y-Tunnus: ${bankDetails ? bankDetails.YTunnus : ''} </p>
            <p class="card-text mb-0"> ALV-Numero: ${bankDetails ? bankDetails.YTunnus : ''} </p>
          </div>
          <div class="mt-md-2 mt-2">
            <h4 class="invoice-title"> Laskuerittely </h4>
            <div class="invoice-date-wrapper">
              <p class="invoice-date-title" style="width: 12rem;"> Laskun päiväys: </p>
              <p class="invoice-date"> ${invoiceData.date.toDate().toLocaleDateString('fi')} </p>
            </div>
            <div class="invoice-date-wrapper">
              <p class="invoice-date-title" style="width: 12rem;"> Toimituspäivämäärä: </p>
              <p class="invoice-date"> ${invoiceData.date.toDate().toLocaleDateString('fi')} </p>
            </div>
            <div class="invoice-date-wrapper">
              <p class="invoice-date-title" style="width: 12rem;"> Eräpäivä: </p>
              <p class="invoice-date"> ${invoiceData.dueDate.toDate().toLocaleDateString('fi')} </p>
            </div>
          </div>
        </div>
      </div>
      <hr class="invoice-spacing">
      <div class="card-body invoice-padding pt-0">
        <div class="row invoice-spacing">
          <div class="p-0 col-xl-6 col-12">
            <h6 class="mb-25"> ${invoiceData.name ?? ''} </h6>
            <p class="card-text mb-25"> ${invoiceData.contact ?? ''} </p>
          </div>
          <div class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end col-xl-6 col-12"></div>
        </div>
      </div>
      <div class="table-responsive">
        <table role="table" aria-busy="false" aria-colcount="5" class="table b-table" id="__BVID__181">
          <thead role="rowgroup">
            <tr role="row">
              <th role="columnheader" scope="col" class="table-b-table-default" style="width: 40%">
                <div>Työntekijä/Pvm</div>
              </th>
              <th role="columnheader" scope="col" class="table-b-table-default" style="width: 10%">
                <div>Määrä</div>
              </th>
              <th role="columnheader" scope="col" class="table-b-table-default" style="width: 20%">
                <div>Hinta</div>
              </th>
              <th role="columnheader" scope="col" class="table-b-table-default" style="width: 20%">
                <div>Yhteensä</div>
              </th>
            </tr>
          </thead>
          <tbody role="rowgroup">
            ${invoiceData.items.map(item => `
                <tr role="row">
                  <td role="cell"> ${item.title} </td>
                  <td role="cell"> ${parseFloat(item.qty).toFixed(2)} ${item.unit}</td>
                  <td role="cell">
                    <p class="card-text mb-25"> ${parseFloat(item.cost).toFixed(2)} € </p>
                  </td>
                  <td role="cell">
                    <p class="card-text mb-25"> ${parseFloat(item.total).toFixed(2)} € </p>
                  </td>
                </tr>
              `).join('')}
          </tbody>
        </table>
      </div>
      <hr class="invoice-spacing">
      <div class="card-body invoice-padding pb-0">
        <div class="row">
          <div class="mt-md-0 mt-3 col-md-6 order-md-1 col-12 order-2"></div>
          <div class="mt-md-6 d-flex justify-content-end col-md-6 order-md-2 col-12 order-1">
            <div class="invoice-total-wrapper">
              <div class="invoice-total-item">
                <p class="invoice-total-title"> Yhteensä veroton: </p>
                <p class="invoice-total-amount"> ${parseFloat(invoiceData.total).toFixed(2)} € </p>
              </div>
              <hr class="my-50">
              <div class="invoice-total-item">
                <p class="invoice-total-title"> Yhteensä: </p>
                <p class="invoice-total-amount"> ${parseFloat(invoiceData.total).toFixed(2)} € </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="invoice-spacing">
    </div>
  `
}

const downloadInvoice = async invoiceData => {
  const element = await createElementPdf(invoiceData)
  const from = invoiceData.date.toDate().toLocaleDateString('fi')
  const to = invoiceData.dueDate.toDate().toLocaleDateString('fi')

  const opt = {
    filename: `lasku_${invoiceData.name}_${from}_${to}.pdf`,
    pagebreak: { avoid: ['h2', 'h3', 'h4', 'tr'] },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  }

  await html2pdf().set({ margin: 5 }).from(element).set(opt)
    .save()
}

export {
  exportCSVList,
  downloadInvoice,
  getCost,
  getOverHoursInPeriod,
  createJaksoPeriodInvoice,
  getHoliday,
  getEve,
}
